export const fontWeightTokens = {
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700
};
